export default "__VITE_ASSET__6e90ebe7__"